import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { BasicInfoApiService } from '@core/http/api/basic-info.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

/**
 * 演示环境横幅。
 *
 * 🔴 这条横幅**不能做成可关闭的**。
 *
 * 演示实例是个公开地址，而且所有访客**共用同一份数据**：A 改的预算，B 刷新就看得见。
 * 界面上一旦没有持续可见的提示，访客会默认「这是我自己的数据」，
 * 于是拿着别人的演示改动当成自己的投放结果去判断 —— 而这类误解没有任何地方会报错。
 *
 * 它同时承担另外两件事：
 *   - 说明「数据是假的」：这里看到的店铺、消耗、报表都不是真实投放；
 *   - 给一个「重置演示数据」的出口：演示被改乱之后能一键回到初始状态。
 *
 * 重置会清掉**所有访客**的改动（不是只清自己的），所以点之前要确认一次。
 */
@Component({
  selector: 'app-demo-banner',
  imports: [NzButtonModule, NzIconModule],
  templateUrl: './demo-banner.component.html',
  styleUrl: './demo-banner.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoBannerComponent {
  private basicInfoApi = inject(BasicInfoApiService);

  resetting = signal(false);
  errorMessage = signal('');

  reset(): void {
    if (
      !window.confirm(
        '重置会清空所有访客的改动（新建的计划、改过的预算和出价等），恢复到初始演示数据。\n\n继续？'
      )
    ) {
      return;
    }

    this.resetting.set(true);
    this.errorMessage.set('');

    this.basicInfoApi.demoReset({}).subscribe({
      next: (response: ApiResponse) => {
        if (response?.info?.ok) {
          window.location.reload();
          return;
        }
        // 后端在并发重置时会回「正在重置中，请稍候再试」—— 原样显示，
        // 不要统一成「重置失败」，那会让人以为要重试的是自己的操作
        this.resetting.set(false);
        this.errorMessage.set(response?.info?.message || '重置失败，请稍后重试');
      },
      error: () => {
        this.resetting.set(false);
        this.errorMessage.set('重置失败，请稍后重试');
      },
    });
  }
}
